import { States } from 'safe'
import { SET_BANKS, BanksTypes } from '../actions/actionTypes'

const initialState: States.Bank = {
  banks: [],
}

//eslint-disable-next-line
export default (state = initialState, action: BanksTypes): States.Bank => {
  switch (action.type) {
    case SET_BANKS:
      return { ...state, banks: action.payload }
    default:
      return state
  }
}
